<template>
  <div
    class="sidebar-modal lg:border-r-1 lg:z-31 z-51 fixed left-0 top-0 h-[var(--app-height)] border-gray-200 bg-white dark:border-neutral-700 dark:bg-neutral-900 md:top-[var(--header-height)] md:h-[calc(var(--app-height)-var(--header-height))]"
    :class="`sidebar-modal-size-${modal.size} sidebar-modal-offset-${modal.offset}`"
  >
    <button
      class="btn btn-primary size-9 absolute right-1 top-1 z-10 justify-center rounded-lg"
      @click.prevent="close"
    >
      <lucide-icon icon="X" size="19" />
    </button>
    <slot></slot>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SidebarModal',
  components: {},
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },

  computed: {},
  methods: {
    ...mapActions(['CLOSE_SIDEBAR_MODAL']),
    close() {
      this.CLOSE_SIDEBAR_MODAL().then(() => {});
    },
  },
};
</script>
